import "styles/Common.css";

import { App as AntApp, ConfigProvider } from "antd";
import { QueryParamProvider } from "use-query-params";
import { ReactRouter6Adapter } from "use-query-params/adapters/react-router-6";

import { AuthProvider } from "hooks/useAuth";
import { ProductProvider } from "hooks/useProduct";
import AppRoutes from "AppRoutes";

const config = {
  token: {
    colorPrimary: "#148FFF",
  },
  components: {
    Layout: {
      headerBg: "#102159",
      bodyBg: "#DEEFF5",
      siderBg: "#0C2055",
    },
  },
};

const App = () => {
  const validateMessages = {
    // eslint-disable-next-line
    required: "${label} is required!",
  };
  return (
    <>
      <ConfigProvider theme={config} form={{ validateMessages }}>
        <AntApp message={{ duration: 2, maxCount: 1 }}>
          <QueryParamProvider adapter={ReactRouter6Adapter}>
            <AuthProvider>
              <ProductProvider>
                <AppRoutes />
              </ProductProvider>
            </AuthProvider>
          </QueryParamProvider>
        </AntApp>
      </ConfigProvider>
    </>
  );
};

export default App;
